import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'

import Header from './components/Header'
import Content from './components/Content'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class GroupStack extends Component {
    static propTypes = {
        groupStackState: IPropTypes.record.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        const {
            groupStackState: { activeGroup },
        } = this.props
        const {
            groupStackState: { activeGroup: nextActiveGroup },
        } = nextProps

        return activeGroup !== nextActiveGroup
    }

    render() {
        const {
            groupStackState: { activeGroup },
        } = this.props

        return (
            activeGroup && (
                <div className="group-stack">
                    <Header />

                    <Content />
                </div>
            )
        )
    }
}
